export type Uid = string;

export interface User {
  id: Uid;
  userData: UserData;
  playerData: PlayerData;
}

export interface UserData {
  playerName: string;
  email: string;
  mobileNumber: string;
  username: string;
  password: string;
}

export interface PlayerData {
  newPlayer: boolean;
  globalRank: number;
  totalPoints: number;
  money: number;
  freeTrades: number;
  currentLineup: Lineup;
  boostedArtist: {
    current?: Uid;
    next?: Uid;
  };
  nextLineup: Lineup;
  hasNews: boolean;
}

// TODO https://my-friend-matt.codecks.io/card/11h-remove-prop-drilling-from-lineup-component
// I need to remove basically all uses of Artist in the UI props and switch them to the cache.
export type Artist = {
  id: Uid;
  name: string;
  // Artist Info needs to be reworked out of the artist,
  // I need to add imageUrl here
  info: ArtistInfo;
};
export type Genre = string;

// Daily Points currently aren't being read, but I'm keeping them in case they need to be shown.
export type ArtistInfo = {
  dailyPoints: number;
  weeklyPoints: number;
  totalPoints: number;
  pointsPerWeek: number;
  streams: {
    daily: number;
    weekly: number;
    total: number;
  };
  social: {
    daily: number;
    weekly: number;
    total: number;
  };
  shows: {
    daily: number;
    weekly: number;
    total: number;
  };
  cost: {
    current: number;
    highest: number;
    previous: number; // Last week's cost
    lowest: number;
    playerPaid: number;
  };
};

export type Lineup = Uid[];

export interface GroupMember {
  id: Uid;
  username: string;
  rank: number;
  score: number;
}

export interface Group {
  id: Uid;
  name: string;
  hostPlayerId: Uid;
  members: GroupMember[];
}

export type SearchType = "artist" | "group";
export type SearchResult = Artist | Group;

export function isSearchResultArtist(res: SearchResult): res is Artist {
  if (typeof res === "string") return false;
  return "info" in res && "streams" in res.info;
}

export function isSearchResultGroup(res: SearchResult): res is Group {
  if (typeof res === "string") return false;
  return "hostPlayerId" in res;
}

export enum Page {
  None = -1,
  Start = 0,
  Main = 1,
  Login = 2,
  SignUp = 3,
  Groups = 5,
  News = 6,
  Welcome = 8,
  OnboardingArtist = 9,
  OnboardingGenre = 10,
  LineupDraftname = 11,
  HowToPlay = 12,
  LineupSelection = 13,
  Settings = 14,
  LeaderboardSelection = 15,
  LeaderboardDetails = 16,
  NewsArticle = 17,
  ExpandedLeaderboard = 18,
}

export interface NewsItem {
  id: Uid;
  headline: string;
  copy?: string;
  isNew?: boolean;
}

export type News = NewsItem[];

export interface ApiResponse {
  success: boolean;
  error?: string;
  data?: unknown;
}

export interface LineupTransaction {
  type: "recruit" | "drop" | "boost" | "remove-boost";
  artistId: Uid;
  cost: number;
  timestamp: number;
}

export interface GetCacheOptions {
  forceRefresh?: boolean;
}
